import styled from "styled-components";
import Page from "../../components/Page";
import withNav from "../../utils/hoc/withNav";
import { connect } from "react-redux";
import { useEffect } from "react";
import Analytics, { TRACK_PAGE_CATEGORIES } from "../../lib/anayltics";
import Button from "../../components/Buttons";

const PageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0 1.5rem;
	flex-grow: 1;
`;

const Title = styled.div`
	font-weight: 600;
	font-size: 25px;
	color: #e8e8e8;
	line-height: 19px;
	text-align: left;
`;

const Subtitle = styled.div`
	font-weight: 500;
	font-size: 18px;
	line-height: 16px;
	text-align: left;
	color: #b6b6b6;
`;

const Space = styled.div`
	margin: 2rem 0 0 0;
`;

const Text = styled.div`
	color: #b6b6b6;
	margin-top: 20px;
	font-size: 14px;
	text-align: left;
	line-height: 16px;
`;

const CenteredRow = styled.div<any>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 1.4rem;
`;

const Disclaimer = styled.div`
	color: rgba(182, 182, 182, 0.6);
	margin-top: 20px;
	font-size: min(3.077vw, 15px);
	text-align: left;
	line-height: 19px;
`;

const AllergensInfo = (props: any) => {
	const { navigate, destinationAfterOnboard, isNewUser } = props;

	function onPageLoad() {
		// if(!isNewUser) {
		// 	navigate.push("/");
		// 	return;
		// }
		Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Allergens Info");
	}

	useEffect(() => {
		onPageLoad();
	}, []);

	return (
		<Page padding="">
			<PageContainer>
				<Title>Allergic to Few Things?</Title>
				<Space />
				<Subtitle>Don't worry we got you covered.</Subtitle>
				<Text>
					Take few seconds to select the items you can't or don't want to eat. We will remember and assist you throughout your
					ordering process.
				</Text>
				<Text>
					You can always set it later in accounts page.
				</Text>
				<CenteredRow>
					<Button onClick={() => navigate.push(destinationAfterOnboard)}>Skip now.</Button>
					<Button isPrimary onClick={() => navigate.push("/onboard/allergens/set")}>
						Set now
					</Button>
				</CenteredRow>
			</PageContainer>
		</Page>
	);
};

const mapStateToProps = (state: any) => {
	const {
		User: { destinationAfterOnboard, isNewUser },
	} = state;
	return { destinationAfterOnboard, isNewUser };
};

export default connect(mapStateToProps, {})(withNav(AllergensInfo));
